import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Flex, Layout, theme, Typography, Grid } from "antd";
import { ReactComponent as AppStore } from "./../../assets/icons/app-store.svg";
import { ReactComponent as GooglePlay } from "./../../assets/icons/google-play.svg";
import phoneImage from "./../../assets/img/footer-phone.png";
import phoneImageMobile from "./../../assets/img/footer-phone-mobile.png";
import { Link } from "react-router-dom";
import { useTranslation } from "@inscore/shared";
import "./appFooter.css";
const { Footer } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const AppFooter = ({ children }) => {
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const isMobile = !screens.lg;
  const { t } = useTranslation();
  const onDownloadButtonClick = (action) => {
    switch (action) {
      case "appStore":
        return window.open(
          "https://apps.apple.com/uy/app/inscore-live-football-scores/id6503955270",
          "_blank",
          "noopener noreferrer"
        );
      case "googlePlay":
        return window.open(
          "https://play.google.com/store/apps/details?id=com.inscore.inscore&hl=en",
          "_blank",
          "noopener noreferrer"
        );
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsx(
    Footer,
    {
      className: "app-footer",
      style: {
        backgroundColor: token.colorBgContainer,
        boxShadow: token.boxShadow,
        borderRadius: token.borderRadius,
        paddingBlock: !screens.md ? 16 : 40,
        paddingInline: !screens.md ? 16 : 50
      },
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: "container",
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: isMobile ? "flex-start" : "center",
            gap: 24
          },
          children: [
            /* @__PURE__ */ jsxs(
              Flex,
              {
                align: isMobile ? "flex-start" : "center",
                justify: !isMobile && "space-between",
                vertical: isMobile,
                style: { width: "100%", padding: isMobile ? 0 : "0 24px" },
                gap: 24,
                children: [
                  /* @__PURE__ */ jsx(Link, { to: "/", children }),
                  /* @__PURE__ */ jsxs(
                    Flex,
                    {
                      gap: isMobile ? 8 : 40,
                      justify: "space-between",
                      style: { width: isMobile ? "100%" : "auto" },
                      children: [
                        /* @__PURE__ */ jsx(
                          Link,
                          {
                            to: "/privacy-policy",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "link-secondary",
                            children: t("privacy_policy")
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Link,
                          {
                            to: "/terms-conditions",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "link-secondary",
                            children: t("terms_of_use")
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Link,
                          {
                            to: "/contact-us",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "link-secondary",
                            children: t("contact_us")
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              Flex,
              {
                vertical: !screens.lg,
                style: {
                  width: "100%",
                  backgroundColor: token.colorBgBase,
                  borderRadius: token.borderRadiusXS,
                  padding: isMobile ? "190px 24px 24px" : "42px 64px",
                  position: "relative",
                  marginTop: isMobile ? 45 : 34
                },
                gap: isMobile ? 20 : 48,
                align: isMobile ? "flex-start" : "center",
                children: [
                  /* @__PURE__ */ jsxs(
                    Flex,
                    {
                      vertical: true,
                      gap: 8,
                      style: { width: isMobile ? "100%" : "382px" },
                      children: [
                        /* @__PURE__ */ jsx(
                          Title,
                          {
                            level: !screens.md ? 4 : 2,
                            style: { margin: 0 },
                            children: t("download_app")
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Text,
                          {
                            style: {
                              fontSize: screens.md ? token.fontSizeLG : token.fontSize,
                              lineHeight: token.lineHeightLG,
                              fontWeight: 600,
                              margin: 0
                            },
                            children: t("download_app_subtitle")
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    Flex,
                    {
                      gap: 16,
                      vertical: true,
                      style: {
                        zIndex: 1,
                        width: !screens.lg ? "100%" : "317px"
                      },
                      children: [
                        /* @__PURE__ */ jsx(
                          Button,
                          {
                            type: "default",
                            icon: /* @__PURE__ */ jsx(AppStore, {}),
                            onClick: () => onDownloadButtonClick("appStore"),
                            style: {
                              padding: "0 8px",
                              height: 48,
                              fontSize: !screens.md ? token.fontSizeLG : token.fontSize,
                              color: token.colorWhite,
                              backgroundColor: "#2A2A2A"
                            },
                            children: t("app_store")
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Button,
                          {
                            type: "default",
                            icon: /* @__PURE__ */ jsx(GooglePlay, {}),
                            onClick: () => onDownloadButtonClick("googlePlay"),
                            style: {
                              padding: "0 8px",
                              height: 48,
                              fontSize: !screens.md ? token.fontSizeLG : token.fontSize,
                              color: token.colorWhite,
                              backgroundColor: "#2A2A2A"
                            },
                            children: t("google_play")
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "img",
                    {
                      src: isMobile ? phoneImageMobile : phoneImage,
                      alt: "footer-phone",
                      style: isMobile ? {
                        position: "absolute",
                        top: "-75px",
                        left: "50%",
                        transform: "translateX(-50%)"
                      } : {
                        position: "absolute",
                        bottom: 0,
                        right: 30
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsx(
              Text,
              {
                style: {
                  color: token.colorTextSecondary
                },
                children: t("copyright")
              }
            )
          ]
        }
      )
    }
  );
};
var stdin_default = AppFooter;
export {
  stdin_default as default
};
